import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-frm',
  templateUrl: './frm.component.html',
  styleUrls: ['./frm.component.css']
})
export class FrmComponent implements OnInit {

  heading = "Shield to UPI Platform";
  subheading = "A Fraud & Risk management solution exclusively designed for UPI and Real time payments";
  innerWidth:number = window.innerWidth;

  slides = [
    {img: "assets/images/frm/text-1.webp",text:"Exclusive Solution For Real Time Payment"},
    {img: "assets/images/frm/text-2.webp",text:"Dashboard To Understand The Ongoing Metrics"},
    {img: "assets/images/frm/text-3.webp",text:"ControlPanel To Configure The Rules"},
    {img: "assets/images/frm/text-4.webp",text:"Zero Performance Overhead"},
    {img: "assets/images/frm/text-5.webp",text:"Less False Positive"},
    {img: "assets/images/frm/text-6.webp",text:"Highly Customisable Rules"},
    {img: "assets/images/frm/text-7.webp",text:"Audit Trials Reports On The System Level Changes"},
    {img: "assets/images/frm/text-8.webp",text:"Historical Transactional Reports"},
    {img: "assets/images/frm/text-9.webp",text:"API Based Integrations With Other Payment Channels"},
    {img: "assets/images/frm/text-10.webp",text:"Behavioral Driven"},
  ];
  slideConfig = {"slidesToShow": 4, "slidesToScroll": 1,"autoplay": true, "autoplaySpeed": 1500, "dots":true,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      // centerMode: true,

    }

  }, {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: true,
      infinite: true,

    }
  },  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
    }
  }]};

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit() {
  }

  breakpoint() {
  }

  afterChange() {
  }

  beforeChange() {
  }
  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) {

    this.canonicalService.setCanonicalURL("https://www.protectt.ai/frm");

   }

  ngOnInit(): void {
    this.titleService.setTitle('Fraud and Risk Management Solutions | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: ' Secure UPI Payment Platform with Innovative Mobile App Shielding - Fraud & Risk management solution | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'Add our Mobile Security App to your devices to protect your valuable information while making Digital Payments. Download the most secure mobile security app now!'});
    this.metaTagService.updateTag(
      { name: 'description', content: 'Fraud and Risk Management Solution provides the best protection for UPI Platforms. It predicts fraudulent transactions and helps to avoid financial losses.' }
    );
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
